module.exports = __webpack_public_path__ + "static/intro_about-f21e557fa5e19d4cc0e454478f08be57.png";